import React from 'react'
import HubspotForm from 'react-hubspot-form'

const PORTAL_ID = 4573758

/**
 * hubspot フォーム
 */
export default props => {
  return (
    <section style={{ margin: '0 auto', ...props.style }}>
      <HubspotForm
        portalId={PORTAL_ID}
        formId={props.formId}
        // onSubmit={() => console.log('Submit!')}
        // onReady={form => console.log('Form ready!')}
        loading={<div>Loading...</div>}
      />
    </section>
  )
}
